'use client';

import { FC } from 'react';
import ListingSliderPopup from './ListingSliderPopup';
import Carousel from 'react-multi-carousel';
import { MyListing } from '@/hotdesk-ui/services/listing.service';
interface ListingSliderpopupClient {
  listings: MyListing[];
  languageCode: string;
  type: string;
  cardType?: 'workspace' | 'listing';
  onClose?: () => void;
}
const ListingSliderPopupClient: FC<ListingSliderpopupClient> = ({
  listings = [],
  languageCode = ' ',
  type,
  cardType = 'listing',
  onClose
}) => {
  const handlePrevClick = (slider: Carousel | null) => {
    if (!slider) {
      return;
    }
    const prevSlide = slider.state.currentSlide - 1;
    slider.goToSlide(prevSlide);
  };
  const handleNextClick = (slider: Carousel | null) => {
    if (!slider) {
      return;
    }
    const prevSlide = slider.state.currentSlide + 1;
    slider.goToSlide(prevSlide);
  };
  return <ListingSliderPopup listings={listings} type={type} languageCode={languageCode} cardType={cardType} onClose={onClose} prevClick={handlePrevClick} nextClick={handleNextClick} data-sentry-element="ListingSliderPopup" data-sentry-component="ListingSliderPopupClient" data-sentry-source-file="ListingSliderPopupClient.tsx" />;
};
export default ListingSliderPopupClient;